// Extrait de NursePatientDetail / DoctorPatientDetail (handover bloc F2, B1) — appels, ordre et messages inchangés.
import { useState, useEffect } from "react";
import api from "@/api";
import { toast } from "sonner";
import { getItems } from "@/utils/apiHelpers";

export default function usePatientDetailData(patientId) {
  const [patient, setPatient] = useState(null);
  const [checkins, setCheckins] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [transmissions, setTransmissions] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [studyEnrollments, setStudyEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    fetchAll();
  }, [patientId]);

  const fetchAll = async () => {
    try {
      const [patRes, checkinRes, alertRes, transRes, docsRes] = await Promise.all([
        api.get(`/patients/${patientId}`),
        api.get(`/patients/${patientId}/checkins?limit=30`).catch(() => ({ data: [] })),
        api.get(`/alerts?patientId=${patientId}`).catch(() => ({ data: { items: [] } })),
        api.get(`/patients/${patientId}/transmissions`).catch(() => ({ data: [] })),
        api.get(`/patients/${patientId}/documents`).catch(() => ({ data: [] })),
      ]);
      setPatient(patRes.data);
      setCheckins(checkinRes.data);
      setAlerts(getItems(alertRes.data));
      setTransmissions(transRes.data || []);
      setDocuments(docsRes.data || []);

      // Fetch study enrollments for this patient
      try {
        const studiesRes = await api.get("/studies?status=active");
        const enrollments = [];
        for (const study of (studiesRes.data || [])) {
          const enrollRes = await api.get(`/studies/${study.id}/enrollments`);
          const mine = (enrollRes.data || []).filter(e => e.patientId === patientId);
          mine.forEach(e => enrollments.push({ ...e, studyName: study.name }));
        }
        setStudyEnrollments(enrollments);
      } catch {
        // Non-blocking
      }
    } catch (err) {
      const status = err?.response?.status;
      const message = status === 403
        ? (err.response?.data?.detail || "Accès non autorisé à ce patient")
        : status === 404 ? "Patient introuvable" : "Erreur lors du chargement";
      setLoadError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return { patient, checkins, alerts, transmissions, documents, studyEnrollments, loading, loadError, fetchAll };
}
